import { render, staticRenderFns } from "./ListDataEditor.vue?vue&type=template&id=08ebbe36&"
import script from "./ListDataEditor.vue?vue&type=script&lang=js&"
export * from "./ListDataEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports